
import { apiClient } from '@/lib/mockApi';


export const useGenericCRUD = () => apiClient;
